import { useInfiniteQuery } from '@tanstack/react-query';
import { ApiResponse, useMemoizedArrayData } from 'hooks/api/api';
import {
  AutomationsTriggersService,
  TCTrigger,
  TCTriggerListResponse,
} from 'src/api/generated';

interface TriggersResponse extends ApiResponse {
  triggers: TCTrigger[];
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
}

export const useTriggers = (
  limit?: number,
  enabled = true
): TriggersResponse => {
  const fetchTriggers = async ({
    pageParam,
  }: {
    pageParam: string | undefined;
  }): Promise<TCTriggerListResponse> => {
    return await AutomationsTriggersService.listTriggers(limit, pageParam);
  };

  const getNextPageParam = (lastPage: TCTriggerListResponse) =>
    lastPage.nextPageToken;

  const {
    data,
    error,
    isLoading: loading,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: ['automations/triggers', { limit }],
    queryFn: fetchTriggers,
    getNextPageParam,
    initialPageParam: undefined,
    enabled,
  });

  const triggers = useMemoizedArrayData<TCTrigger>(
    data?.pages.flatMap((p) => p.items) || []
  );

  return {
    loading,
    error,
    triggers,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  };
};
